import React, {FC} from 'react';
import {useTranslation} from 'react-i18next';
import {provider, useInstance} from 'react-ioc';
import {BrowserRouter as Router, Navigate, Route, Routes,} from 'react-router-dom';
import {YMInitializer} from 'react-yandex-metrika';
import {ApolloClient, ApolloProvider} from '@apollo/client';
import {ConfigProvider, Skeleton} from 'antd';
import en_US from 'antd/locale/en_US';
import es_ES from 'antd/locale/es_ES';
import kk_KZ from 'antd/locale/kk_KZ';
import {observer} from 'mobx-react-lite';

import 'dayjs/locale/ru';

import {Currency} from '../components/common/Currency';
import { Me } from '../components/common/Me';
import { Metrika } from '../components/common/Metrika';
import ScrollToTop from '../components/common/ScrollToTop';
import Layout from '../components/layout/Layout';
import {PaymentPage} from '../components/Payment/PaymentPage';
import {
    INDEX, LOGIN, PAYMENT, PAYMENT_UPDATE, REGISTRATION,
    ROOT,
} from '../config/routes';
import ApolloClientDI from '../model/graphql/ApolloClientDI';
import {Store} from '../model/store/Store';
import StoreDI from '../model/store/StoreDI';
import {Index} from '../pages/index/Index';
import {Login} from '../pages/Login/Login';
import {OrderUpdate} from '../pages/Order/OrderUpdate';
import {Registration} from '../pages/registration/Registration';

import './App.scss';
const App: FC = () => {

    const apolloClient = useInstance(ApolloClient);
    const {hydrated, auth} = useInstance(Store)
    const {i18n} = useTranslation();

    if (!hydrated) {
        return <Skeleton active/>
    }

    let locale = en_US;
    switch (i18n.language) {
        case 'en': locale = en_US;break;
        case 'es': locale = es_ES;break;
        case 'kz': locale = kk_KZ;break;
    }

    return (
        <ConfigProvider locale={locale  } theme={{
            token: {
                colorPrimary: '#5BCC81',
                borderRadius: 8,
                fontFamily: '\'Montserrat\', sans-serif',
                // fontSize: 16,
            },
        }}>
            <ApolloProvider client={apolloClient}>
                <Router>
                    <ScrollToTop/>
                    <YMInitializer accounts={[102875815]}/>
                    <Metrika/>
                    <Currency/>
                    {auth.token !== null && <Me/>}

                    <Routes>
                        <Route path={ROOT} element={<Layout/>}>
                            <Route path={INDEX} element={<Index/>}/>
                            <Route path={REGISTRATION} element={<Registration/>}/>

                            {auth.token === null &&
                                <>
                                    <Route path={LOGIN} element={<Login/>}/>
                                </>
                            }
                            {auth.token !== null  &&
                                <>
                                    <Route path={PAYMENT} element={<PaymentPage/>}/>
                                    <Route path={PAYMENT_UPDATE} element={<OrderUpdate/>}/>
                                    <Route path={LOGIN} element={<Navigate to={INDEX}/>}/>
                                </>
                            }
                            <Route path="*" element={<Navigate to={INDEX}/>}/>
                        </Route>
                    </Routes>
                </Router>
            </ApolloProvider>
        </ConfigProvider>
);
};

export default provider(
StoreDI(),
ApolloClientDI(),
)(observer(App));
